export const CATEGORY_EN_LANG = 'en'

export function cloneCategoryTree (tree) {
  return JSON.parse(JSON.stringify(tree || []))
}

export function buildCategoryNameMap (tree, map = new Map()) {
  for (const item of tree || []) {
    map.set(String(item.categoryId), item.categoryName)
    if (item.childCategoryList?.length) {
      buildCategoryNameMap(item.childCategoryList, map)
    }
  }
  return map
}

export function mergeCategoryNames (structure, nameMap) {
  return (structure || []).map(item => ({
    ...item,
    categoryName: nameMap.get(String(item.categoryId)) ?? item.categoryName,
    childCategoryList: item.childCategoryList?.length
      ? mergeCategoryNames(item.childCategoryList, nameMap)
      : item.childCategoryList
  }))
}

export function pickFirstLevelCategories (tree) {
  return (tree || []).map(({ categoryId, categoryName, icon }) => ({
    categoryId,
    categoryName,
    icon
  }))
}
